import React, { useEffect, useState } from "react";
import { rolsResource } from "../../helpers/configRoutes/backend_helper";
import DataTableElement from "../../components/elements/DataTableElement";
import { columns } from "./Columns";
import RolModal from "./RolModal";
import { useDispatch } from "react-redux";
import { reset_rol, update_rol } from "../../store/rols/action";
import CustomButton from "../../components/form/CustomButton";
import AddUpdRol from "./AddUpdRol";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";

const Rols = () => {
    const dispatch = useDispatch()
    const [tableLoad, setTableLoad] = useState({
        show: false,
        textLoad: "Loading role...",
    });

    const [filters, setFilters] = useState({
        perPage: 20,
        page: 1,
    });

    const [items, setItems] = useState([]);
    const [modalRow, setModalRow] = useState({ show: false })
    const [modal, setModal] = useState({ show: false })
    const [modalConfirm, setModalConfirm] = useState({
        show: false,
        title: "Delete Role",
        loading: false,
        textLoad: "Processing",
    })

    useEffect(() => {
        const getItems = async () => {
            setTableLoad((prev) => ({ ...prev, show: true }));

            const response = await rolsResource("get", { params: filters });

            if (response.status) {
                setItems(response.rols || []);
            }

            setTableLoad((prev) => ({ ...prev, show: false }));
        };

        getItems();
    }, [filters]);

    const openModalAdd = (roleItem = {}) => {
        dispatch(roleItem.id ? update_rol(roleItem) : reset_rol())

        setModal({
            ...modal,
            show: true,
            title: roleItem.id ? "Edit Role" : "Add Role",
        });
    };

    const deleteRol = async () => {
        setModalConfirm((prev) => ({ ...prev, loading: true }));
        const response = await rolsResource("del", {}, modalConfirm.id);

        if (response.status) {
            setFilters((prev) => ({ ...prev }));
        }

        setModalConfirm((prev) => ({
            ...prev,
            loading: false,
            show: false,
            id: null,
        }));
    };

    const cols = columns(setModalRow, openModalAdd, setModalConfirm, modalConfirm);

    return (
        <>
            <div className="min-h-screen bg-cs-surface">
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                    <div>
                        <h1 className="text-2xl font-semibold text-cs-dark">
                            User Roles
                        </h1>
                        <p className="text-sm text-cs-muted mt-1">
                            Manage user roles and permissions.
                        </p>
                    </div>

                    <div className="flex items-center gap-3">
                        <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
                            Total roles:{" "}
                            <span className="font-semibold text-cs-dark">
                                {items.length}
                            </span>
                        </div>
                        <CustomButton
                            onClick={() => openModalAdd()} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
                            + Create New Role
                        </CustomButton>
                    </div>
                </div>

                {/* Table */}
                <div
                    className="
                        bg-cs-bg border border-cs-border rounded-2xl
                        shadow-sm px-2 py-2
                    "
                >
                    <DataTableElement
                        columns={cols}
                        items={items}
                        tableLoad={tableLoad}
                    />
                </div>
            </div>

            {/* Modals */}
            {modalRow.show &&
                <RolModal modal={modalRow} setModal={setModalRow} />
            }

            {modal.show &&
                <AddUpdRol modal={modal} setModal={setModal} setFilters={setFilters} filters={filters} />
            }

            <ConfirmDeleteModal
                modal={modalConfirm}
                setModal={setModalConfirm}
                action={deleteRol}
            />
        </>
    );
};

export default Rols;
